import { CapacitorHttp } from '@capacitor/core';
import { Capacitor } from '@capacitor/core';

const API_BASE_URL = process.env.VUE_APP_API_URL || 'http://192.168.1.26:8000/api';

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
    this.isNative = Capacitor.isNativePlatform();
  }

  async request(method, endpoint, data = null, customHeaders = {}) {
    const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...customHeaders
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const options = {
      url: `${this.baseURL}/${endpoint}`,
      headers,
    };

    if (data) {
      options.data = data;
    }

    try {
      let response;
      
      if (this.isNative) {
        // Use CapacitorHttp for native mobile
        switch (method.toLowerCase()) {
          case 'get':
            response = await CapacitorHttp.get(options);
            break;
          case 'post':
            response = await CapacitorHttp.post(options);
            break;
          case 'put':
            response = await CapacitorHttp.put(options);
            break;
          case 'delete':
            response = await CapacitorHttp.delete(options);
            break;
          default:
            throw new Error(`Unsupported method: ${method}`);
        }
        return response.data;
      } else {
        // Use regular fetch for web
        const fetchOptions = {
          method: method.toUpperCase(),
          headers,
        };

        if (data && method.toLowerCase() !== 'get') {
          fetchOptions.body = JSON.stringify(data);
        }

        const response = await fetch(options.url, fetchOptions);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        return await response.json();
      }
    } catch (error) {
      console.error(`API ${method.toUpperCase()} Error:`, error);
      throw error;
    }
  }

  get(endpoint, headers = {}) {
    return this.request('get', endpoint, null, headers);
  }

  post(endpoint, data, headers = {}) {
    return this.request('post', endpoint, data, headers);
  }

  put(endpoint, data, headers = {}) {
    return this.request('put', endpoint, data, headers);
  }

  delete(endpoint, headers = {}) {
    return this.request('delete', endpoint, null, headers);
  }
}

export default new ApiService();